<template>
  <div class="about-us-page">
    <fancy-header></fancy-header>
    <div class="container">
        <div class="row about-us-row">
            <div class="col-md-5 col-sm-6 col-xs-6 col-xxs-12 logo-container">
                <div class="img-container">
                    <div class="content">
                        <img src="/src/assets/img/logo.png"/>
                    </div>
                </div>
            </div>
            <div class="col-md-7 col-xs-6 col-xxs-12">
              <div class="info">
                   <div>
                        <p>
                                بدأت <span class="co-orange">Beetronix</span> عملها في أيام الأزمة السورية في الشهر الثاني من عام 2014 في مدينة حلب وركزت في توجهها على تأهيل
                            كوادرها بمختلف اختصاصاتهم لتتمكن من تقديم مختلف أنواع الحلول البرمجية والإلكترونية.
                        </p>
                </div>
                <div>
                    <p>
                        
إن فكرة الجمع بين الحلول البرمجية والإلكترونية في كيان واحد تمكننا من الارتقاء في نوعية المنتجات والمشاريع التي نستطيع تقديمها
فلا حدود إلكترونية أو برمجية تعيق طريق تنفيذ أي مشروع كما ويمكننا ذلك من تصميم حلولنا ومنتجاتنا المتكاملة بنكهتنا وأسلوبنا الخاص.

                    </p>
                </div>
                <div>
                    <p>
إن ما يدفعنا للتحرك نحو الامام هو إيماننا بأن مسؤولية تطوير البلاد هي على عاتق شبابها ولهذا نحرص على تبني الأفكار الشابة واستقطاب ما أمكن من الكوادر الشابة لدعم مسيرة التطوير والتحديث.</p>
                </div>
                <div>
                    <p>رسالة الشركة: <br/>
تتلخص رسالتنا في الجملة التالية:</p>
                </div>
                <div class="text-center">
                    <p>
“دعم التنمية التقنية والعلمية في سوريا ودعم أعمال الابتكار والإختراع بمختلف أنواعها لبناء سوريا المستقبل التي تتسم بالتطور والقوة”
                    </p>
                </div>
              </div>
            </div>
        </div>
    </div>
    </div>
  
</template>
<script>
import FancyHeader from '@/components/shared/fancy-header'

export default {
    name:'AboutUs',
    
    components: {
        FancyHeader
    }
}
</script>
<style lang="scss" scoped>
  @import "src/assets/sass/shared.scss";
    .container{
        padding:50px;
    }
        .about-us-row{
            & > div{
                @include float-left($dir);
            }
            .logo-container{
                display: flex;
                justify-content: center;
                align-items: center;

                .img-container{
                    width:60%;

                    @include aspect-ratio(3,4);
                    img{
                        width:100%;
                    }
                }
            }
            .info{
                & > div{
                    margin-bottom:10px;
                }
                p{
                    color:$p-color;
                    font-size:19px;
                    @include text-align($dir);
                    direction:$dir;
                    @media(max-width:480px){
                        text-align: center;
                    }
                }
            }
        }
</style>



// WEBPACK FOOTER //
// src/components/about-us.vue